import { MAKEUP_V3_BRIDAL_LOOKS } from './makeupV3BridalLooks';
import { MAKEUP_V3_EVERYDAY_PRESETS } from './makeupFluxV3TimePresets';

export const MAKEUP_V3_LOOK_PICKER_TABS = [
  { id: 'recommended', label: 'Recommended' },
  { id: 'all', label: 'All styles' },
];

const EVERYDAY_RECOMMENDED_IDS = [
  'morning-sheer',
  'day-office',
  'evening-rose-gold',
  'night-party',
];

export function recommendedEverydayPresets() {
  const byId = new Map(MAKEUP_V3_EVERYDAY_PRESETS.map((p) => [p.id, p]));
  const picked = EVERYDAY_RECOMMENDED_IDS.map((id) => byId.get(id)).filter(Boolean);
  if (picked.length >= 3) return picked;
  return MAKEUP_V3_EVERYDAY_PRESETS.slice(0, 4);
}

export function recommendedBridalLooks() {
  return MAKEUP_V3_BRIDAL_LOOKS;
}

export function filterEverydayPresets(mode) {
  if (mode === 'recommended') return recommendedEverydayPresets();
  return MAKEUP_V3_EVERYDAY_PRESETS;
}

export function filterBridalLooks(mode) {
  if (mode === 'recommended') return recommendedBridalLooks();
  return MAKEUP_V3_BRIDAL_LOOKS;
}
